import { render, staticRenderFns } from "./PdfPreviewer.vue?vue&type=template&id=61f492ca&scoped=true"
import script from "./PdfPreviewer.vue?vue&type=script&lang=js"
export * from "./PdfPreviewer.vue?vue&type=script&lang=js"
import style0 from "./PdfPreviewer.vue?vue&type=style&index=0&id=61f492ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f492ca",
  null
  
)

export default component.exports